import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import {
  HireTeamDubaiIcon,
  HireDevDubaiIcon,
  HireRemDubaiIcon,
  HireOrangeDubaiIcon,
} from "../../../app-constants";
import BgImg from "../../images/locationgcc/hire-dubai/engagement_models.webp";

function Hireengagementmodels() {
  return (
    <div
      className="hire_engagement_models p-100"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row>
          <Col xs={12} md={12} lg={7} xl={7} xxl={7} className="">
            <h2>3 Easy Engagement Models To Help Hire A Developer in UAE</h2>
          </Col>
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="">
            <p>
              Choose from our 3 user-friendly engagement models designed for
              effortless hiring of developers in UAE, ensuring simplicity and
              flexibility in your selection process.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="">
            <div className="engagement_box">
              <div className="engagement_img">{HireTeamDubaiIcon}</div>
              <div className="engagement_content">
                <h6>
                  Hire Top App
                  <br /> Development Team
                </h6>
                <p>
                  Enjoy unlimited time flexibility, with the option to add or
                  remove resources anytime.
                </p>
                <div className="engagement_btn">
                  <Link
                    to="/contact"
                    className=""
                    aria-label="TekRevol Contact"
                  >
                    Hire A Developer {HireOrangeDubaiIcon}
                  </Link>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="">
            <div className="engagement_box">
              <div className="engagement_img">{HireDevDubaiIcon}</div>
              <div className="engagement_content">
                <h6>
                  Hire Developers Onsite for
                  <br /> Contractual Basis
                </h6>
                <p>
                  Ideal for projects with a fixed scope, ensuring clear project
                  completion periods and budgets.
                </p>
                <div className="engagement_btn">
                  <Link
                    to="/contact"
                    className=""
                    aria-label="TekRevol Contact"
                  >
                    Hire A Developer {HireOrangeDubaiIcon}
                  </Link>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="">
            <div className="engagement_box">
              <div className="engagement_img">{HireRemDubaiIcon}</div>
              <div className="engagement_content">
                <h6>
                  Hire Remote Developers On
                  <br /> Hourly Basis
                </h6>
                <p>
                  Pay only for the hours you need, with the flexibility to add
                  development hours as required.
                </p>
                <div className="engagement_btn">
                  <Link
                    to="/contact"
                    className=""
                    aria-label="TekRevol Contact"
                  >
                    Hire A Developer {HireOrangeDubaiIcon}
                  </Link>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Hireengagementmodels;
